// 「どのページの」「どのような操作に対して」「誰が行えるか」の認可を行う
const operation = {
    // 履歴画面｜プラン期間外の参照
    history: {
        outOfRetentionPeriodRead: {
            sysadmin: true,
            production: true,
            aspadmin: true,
            useradmin: false,
            user: false
        }
    },
}

// 誰が、どのページの、どのような操作を行いたいのかを順に指定する
const userAuthTypeAuthorization = (authType, page, verb) => {
    if(authType != "") {
        return operation[page][verb][authType]
    } else {
        return false;
    }
}

export default userAuthTypeAuthorization